import { render } from "./EPedidoDetalleModal.vue?vue&type=template&id=6579527c"
import script from "./EPedidoDetalleModal.vue?vue&type=script&lang=js"
export * from "./EPedidoDetalleModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__